module.exports = __webpack_public_path__ + "illinois-58118b745f0dbb571066f5f8e39c525d.svg";